import { render, staticRenderFns } from "./WeekViewDb.vue?vue&type=template&id=8fcac388"
import script from "./WeekViewDb.ts?vue&type=script&lang=ts&external"
export * from "./WeekViewDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports